export enum CashRegisterOperationMode {
  Standalone = "Standalone",
  SemiIntegrated = "SemiIntegrated",
  PosWithTwoScreens = "PosWithTwoScreens"
}

export enum CashRegisterMarketingMode {
  ReceiptOnly = "ReceiptOnly",
  Auto = "Auto"
}

export enum CashRegisterAutomationMode {
  StaticThankYouPage = "StaticThankYouPage",
  PosRules = "PosRules"
}

export enum CashRegisterSliderTapAction {
  RedirectToPaymentScreen = "RedirectToPaymentScreen",
  None = "None"
}

export interface CashRegisterAutomatedPosMarketingDto {
  automationMode: CashRegisterAutomationMode;
}

export interface CashRegisterMarketingSliderDto {
  showMarketingSlider: boolean;
  sliderTapAction: CashRegisterSliderTapAction;
}

export interface CashRegisterSettingsDto {
  operationMode: CashRegisterOperationMode;
  postTransactionMarketingMode: CashRegisterMarketingMode;
  automatedPosMarketing: CashRegisterAutomatedPosMarketingDto;
  marketingSlider: CashRegisterMarketingSliderDto;
}

export interface CashRegisterSettingsPutDto {
  modes: CashRegisterSettingsDto[];
}
